import {Registered} from '@/Manager';
import {Equipe} from '@/models/Equipe';
import manager from '@/Manager/Manager';
import {Player} from '@/models/Player';

export class Match extends Registered {
	
	public expend: boolean = false;
	private _equipes: Equipe[][] = [];
	
	public get matchs(): Equipe[][] {
		return this._equipes;
	}
	
	public isJouer(index: number) {
		return !!this._equipes[index][0].score || !!this._equipes[index][1].score;
	}
	
	public isWin(index: number, player: Player) {
		return (this._equipes[index][0].score >= 13 && this._equipes[index][0].players.indexOf(player) !== -1) ||
			(this._equipes[index][1].score >= 13 && this._equipes[index][1].players.indexOf(player) !== -1)
		;
	}
	
	public hasPlayer(index: number, player: Player): boolean {
		return this._equipes[index][0].players.indexOf(player) !== -1 || this._equipes[index][1].players.indexOf(player) !== -1;
	}
	
	public score(index: number, player: Player) {
		if (this._equipes[index][0].players.indexOf(player) !== -1) {
			return this._equipes[index][0].score;
		}
		if (this._equipes[index][1].players.indexOf(player) !== -1) {
			return this._equipes[index][1].score;
		}
		return 0;
	}
	
	public addEquipes(equipes: Equipe[]): this {
		this._equipes.push(equipes);
		return this;
	}
	
	public get equipes(): Equipe[][] {
		return this._equipes;
	}
	
	public register(): void {
		this._equipes.forEach(es => es.forEach(e => {
			manager.register(e);
		}));
	}
	
	public toJSON(): any {
		return {
			__className__: 'Match',
			equipes: this._equipes.map(es => es.map(e => e.id)),
		};
	}
	
	public fromJSON(data: any): this {
		this._equipes = <Equipe[][]>data.equipes.map(ids => ids.map(id => manager.find(id)));
		return this;
	}
}